export default __webpack_public_path__ + "static/media/logout.53ed52ce.png";